<template>
<div>
  <!-- start:: mobile menu -->
  <div id="overlay-mobile-menu" class="hide"></div>
  <div id="mobile-menu-conatiner" class="d-flex flex-column justify-content-between hide">
    <div class="exit-mobile-menu hide_seek"><i class="fas fa-times"></i></div>
    <div class="menu-mobile">
      <HeadMobileMenu v-if="!disableNavigation && (customer || dealer || user?.active_admin)" @closeMobileMenu="toggle()" />
    </div>
    <div class="options-mobile">
      <div class="options-mobile-item" v-on:click="logout"> <i class="fas fa-sign-out-alt"></i> {{$t("Logout")}}</div>
    </div>
  </div>
  <!-- end:: mobile menu -->

  <!-- start:: mobile header -->
  <header class="d-lg-none">
    <div class="container">
      <div class="row">
        <div class="col-md-12 d-flex flex-row justify-content-between">
          <div class="logo-header">
            <router-link :to="{name: disableNavigation ? $route.name : 'Home'}">
              <img v-if="$store.getters['account/group'] === 'dealer'" src="/img/logo-xdealer.svg" alt="">
              <img v-else-if="$store.getters['account/group'] === 'customer'" src="/img/logo-xstore.svgs" alt="">
              <img v-else src="/img/logo-admin.svg" alt="">
            </router-link>
          </div>
          <!-- start:: mobile menu -->
            <div>
                <div class="icon-open-mobile-menu hide_seek">
                    <i class="fas fa-bars btn"></i>
                </div>
                <div class="icon-open-mobile-ninedots">
                    <nine-dots is-mobile></nine-dots>
                </div>
            </div>
          <!-- end:: mobile menu -->
        </div>
      </div>
    </div>
  </header>
  <!-- end:: mobile header -->

  <!-- start:: no mobile header -->
	<!-- NOTE: Il colore del border botton cambia in base al ruolo utente -->
  <div class="menu-container d-none d-lg-block">
    <div class="container">
      <div class="row">
        <div class="col-md-12 d-flex flex-row justify-content-between">
          <div class="logo-header">
            <router-link  :to="{name: disableNavigation ? $route.name : 'Home'}">
              <img v-if="$store.getters['account/group'] === 'dealer'" src="/img/logo-xdealer.svg" alt="">
              <img v-else-if="$store.getters['account/group'] === 'customer'" src="/img/logo-xstore.svg" alt="">
              <img v-else src="/img/logo-admin.svg" alt="">
            </router-link>
          </div>
          <HeadCenterMenu v-if="!hideCenterMenu && (customer || dealer || user?.active_admin)"/>
          <HeadSideMenu v-if="!hideSideMenu" :hide-account-menu="disableNavigation || (!customer && !dealer && !user?.active_admin)" />
        </div>
      </div>
    </div>
  </div>
  <!-- end:: no mobile header -->
</div>
</template>

<script>
import HeadCenterMenu from './HeadCenterMenu.vue'
import HeadSideMenu from './HeadSideMenu.vue'
import HeadMobileMenu from './HeadMobileMenu.vue'
import NineDots from "./NineDots.vue";

export default {
      name: 'app-header',
      props: ['hideCenterMenu', 'hideSideMenu', 'disableNavigation'],
      components: {
          NineDots,
          HeadCenterMenu,
          HeadSideMenu,
          HeadMobileMenu
      },
      data:() => ( {
        navItems: [],
        navSideItems: [],
        customer: {},
        dealer: {},
        user: {}
      }),
      mounted(){
        this.navItems = this.$store.getters.getMenu;
        this.navSideItems = this.$store.getters.getSideMenu;
        this.customer = this.$store.getters.getCustomer;
        this.dealer = this.$store.getters.getDealer;
        this.user = this.$store.getters.getUser;

        $('.hide_seek').click(function() {
          $('#mobile-menu-conatiner').toggleClass('hide');
          $('#overlay-mobile-menu').toggleClass('hide');
        });
      },
      computed: {
          isLoggedIn: function () {
            return this.$store.getters['account/isLoggedIn'];
          },
          userName: function () {
            let user = this.$store.getters.getUser;
            return user.name + ' ' + user.surname;
          }
      },
      methods: {
          logout: function () {
              this.$store.dispatch('account/logout')
                  .then(() => {});
          },
          navColor: function() {
            let group = this.$store.getters['account/user'].group;
              if (group === 'customer')
                  return '#f0000a';
              else if (group === 'dealer')
                  return '#c0d6e5';
              else if (group === 'admin')
                  return '#f0000a';
          },
          toggle() {
            $('#mobile-menu-conatiner').toggleClass('hide');
            $('#overlay-mobile-menu').toggleClass('hide');
          }
      },
  }
</script>
